const transformInputText = () => {
  const vrnInput = document.getElementById(
    'wizard_vehicle_enquiry_capture_vrn_vrn'
  )
  if (vrnInput) {
    vrnInput.addEventListener('input', (event) => {
      const target = event.target;
      const start = target.selectionStart;
      const end = target.selectionEnd;

      target.value = target.value.replace(/[^a-zA-Z\d\s]/g, "");
      target.value = target.value.toLocaleUpperCase();
      target.setSelectionRange(start, end);
    })
  }
}

export { transformInputText }
